import { createSelector } from '@reduxjs/toolkit';
import { getSalesSpaceListState } from './getSalesSpaceListState';

export const getSalesSpaceUnreadMessagesFilterSelected = createSelector(
  getSalesSpaceListState,
  (channelList) => channelList.unreadMessagesFilterSelected,
);
